export default __webpack_public_path__ + "static/media/rafode.c44a1cf2.jpg";